module.exports = __webpack_public_path__ + "static/media/mastercard.6c49de10.svg";